import React, {Component} from 'react';
import './PlanItem.css';
import PropTypes from 'prop-types';
import axios from 'axios';
import moment from 'moment';

export default class PlanItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            processingCheck: false
        };
    }

    handleCheckClick() {
        if (this.state.processingCheck || this.props.hideCompletion) {
            return;
        }

        this.setState({
            processingCheck: true
        });

        let payload = {
            task_id: this.props.task.id,
            is_complete: !this.props.task.is_complete
        };

        let apiUrl = '/tasks/complete';

        if (this.props.seedMode) {
            apiUrl = `/tasks/seed`;
        }

        axios.post(apiUrl, payload)
            .then((res) => {
                if (res.data.ok) {
                    this.props.onTaskChecked(res.data.is_complete);
                }
            })
            .catch((err) => {
                console.error('PlanItem, check click POST failure:', err);
            })
            .then(() => {
                this.setState({
                    processingCheck: false
                });
            })
    }

    handleDeleteClick() {
        this.props.onDeleteClicked();
    }

    handleTaskClick() {
        if (this.props.seedMode) {
            this.handleCheckClick();
            return;
        }

        ////////////////////////////////////////

        if (this.props.onTaskClick) {
            this.props.onTaskClick();
        }
    }

    render() {
        let isComplete = !this.props.hideCompletion && !!this.props.task.is_complete;

        let classNames = ["PlanItem"];
        let checkClassNames = ["PlanItem__check"];

        if (isComplete) {
            classNames.push("PlanItem--checked");
            checkClassNames.push("PlanItem__check--checked");
        } else {
            checkClassNames.push("PlanItem__check--unchecked");
        }

        let subText = null;

        if (this.props.task.end_date) {
            let parsedEndDate = moment(this.props.task.end_date);

            if (parsedEndDate.isValid()) {
                subText = parsedEndDate.format("dddd D MMMM YYYY");
            }
        } else if (this.props.task.start_time || this.props.task.end_time ){
            subText = "";

            if (this.props.task.start_time) {
                subText += this.props.task.start_time.toString() + " ";
            }

            if (this.props.task.end_time) {
                subText += "- ";
                subText += this.props.task.end_time.toString();
            }
        }

        let completionLabel = isComplete ? "Markeren als niet voltooid" : "Markeren als voltooid"; // seedMode
        let canDelete = !this.props.hideControls;

        if (this.props.seedMode) {
            completionLabel = "Actie selecteren";
            canDelete = false;
            subText = <div className={"PlanItem__seed-html"} dangerouslySetInnerHTML={{__html: this.props.task.description}}/>;
            classNames.push("PlanItem--seed");
        }

        return (
            <div className={classNames.join(' ')}>
                {!this.props.hideCompletion &&
                <div className={"PlanItem__check-wrap"}>
                    <a className={checkClassNames.join(' ')} onClick={this.handleCheckClick.bind(this)}
                       title={completionLabel}>
                        <i className={"mdi mdi-check"}/>
                    </a>
                </div>
                }
                <div className={"PlanItem__text"} onClick={this.handleTaskClick.bind(this)}>
                    <strong className={"PlanItem__text-title"}>{this.props.task.name}</strong>
                    {subText && <p className={"PlanItem__text-sub"}>{subText}</p>}
                </div>
                <div className={"PlanItem__filler"}/>
                <div className={"PlanItem__controls"}>
                    {canDelete &&
                    <a className={"PlanItem__controls-item"} onClick={this.handleDeleteClick.bind(this)}
                       title={"Taak verwijderen"}
                    >
                        <i className={"mdi mdi-delete"}/>
                    </a>
                    }
                </div>
            </div>
        );
    }
}

PlanItem.propTypes = {
    task: PropTypes.object.isRequired,
    onTaskClick: PropTypes.func,
    onTaskChecked: PropTypes.func.isRequired,
    onDeleteClicked: PropTypes.func,
    seedMode: PropTypes.bool,
    checkValue: PropTypes.bool,
    hideCompletion: PropTypes.bool,
    hideControls: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/Portal/Planner/PlanItem.js